function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.6 14.1c.3 0 .5-.1.7-.2s.2-.3.2-.4v-.2-.2-.2-.3c0-.2.1-.4.2-.6s.2-.3.4-.5l.5-.5c.2-.2.4-.3.5-.6s.3-.4.4-.7.2-.5.2-.9c0-.3-.1-.7-.2-.9-.1-.2-.5-.3-.7-.5s-.5-.4-.9-.5-.8-.2-1.2-.2c-.3 0-.5 0-.7.1s-.5.1-.6.2-.4.1-.5.2-.2.1-.3.2l-.2.2c-.1.1 0 .2 0 .3 0 .2.1.3.2.4s.2.2.4.2h.2s.2-.1.3-.1.2-.1.3-.1h.5c.2 0 .4 0 .6.1.2.1.3.1.4.2.1.1.2.2.2.3s.1.3.1.4c0 .2-.1.4-.2.6s-.2.2-.4.4l-.5.5-.5.5c-.2.2-.3.4-.4.6s-.2.5-.2.8c0 .2 0 .4.1.6s.1.3.2.4.3.3.5.3.2.1.4.1zm0 3c.2 0 .3 0 .5-.1.1-.1.3-.1.4-.2.1-.1.2-.2.2-.4s.1-.3.1-.5 0-.3-.1-.5-.1-.3-.2-.4-.2 0-.4 0-.3-.1-.5-.1-.3 0-.5.1-.3.1-.4.2-.2.2-.2.4v.4c0 .1 0 .3.1.4s.1.3.2.3.2.2.4.2.3.2.4.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-22.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5z"
});

function SvgHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgHelpIcon;